/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import { gsap } from 'gsap';
import { Mesh, type ShaderMaterial, type Texture } from 'three';

import Geometry from './Geometry';
import Material from './Material';

export default class LQParticles extends Mesh {
    _noiseTexture?: Texture;
    _particleTexture?: Texture;
    private _count: number;
    private _particleScale: number;
    constructor(camera) {
        const geo = new Geometry();
        const mat = new Material(camera);
        super(geo, mat);
        this._count = 1000;
        this._particleScale = 2;
        geo.setIdleBuffers(this._count, this._particleScale);
        this.visible = false;

        this.isAnimatingIn = false;
    }

    transitionIn() {
        if (this.material.uniforms.particleOpacity.value > 0) return;
        if (this.isAnimatingIn) return;
        this.isAnimatingIn = true;
        this.visible = true;
        gsap.killTweensOf(this.material.uniforms.particleOpacity);
        gsap.fromTo(
            this.material.uniforms.particleOpacity,
            {
                value: 0,
            },
            {
                value: 1.0,
                ease: 'power1.inOut',
                delay: 1.0,
                duration: 2,
                onComplete: () => {
                    this.isAnimatingIn = false;
                },
            },
        );
    }

    transitionOut() {
        gsap.killTweensOf(this.material.uniforms.particleOpacity);
        gsap.to(this.material.uniforms.particleOpacity, {
            value: 0,
            duration: 1,
            onComplete: () => {
                this.visible = false;
            },
        });
    }

    hide() {
        this.material.uniforms.particleOpacity.value = 0;
    }

    updateParticleCount(count: number) {
        const geo = this.geometry as Geometry;
        geo.dispose();
        geo.setIdleBuffers(count, this._particleScale);
        this._count = count;
    }

    updateParticleSize(particleScale: number) {
        const geo = this.geometry as Geometry;
        geo.dispose();
        geo.setIdleBuffers(this._count, particleScale);
    }

    set noiseTexture(texture: Texture) {
        this._noiseTexture = texture;
    }

    set particleTexture(texture: Texture) {
        this._particleTexture = texture;
        const mat = this.material as ShaderMaterial;
        mat.uniforms.particleTexture.value = this._particleTexture;
    }

    delete() {
        const geo = this.geometry as Geometry;
        geo.dispose();
        const mat = this.material as ShaderMaterial;
        mat.dispose();
    }
}
